import { useTranslation } from 'react-i18next';
import { OrderClaimData } from '../../../types';
import { Empty, Grid, Steps } from 'antd';

type ClaimProgressProps = {
  orderClaimDetail: OrderClaimData;
};

const ClaimProgress = ({ orderClaimDetail }: ClaimProgressProps) => {
  const { t } = useTranslation();
  const screens = Grid.useBreakpoint();

  const currentStep = () => {
    if(orderClaimDetail.isDelete){
        return undefined
    }
    if (orderClaimDetail.isUsed && orderClaimDetail.usedTime) {
      // 使用时间
      return 3;
    } else if (orderClaimDetail.isRead && orderClaimDetail.readTime) {
      // 已读时间（optional)
      return 2;
    } else if (orderClaimDetail.reviewTime) {
      // 审核时间
      return 1;
    } else if (orderClaimDetail.addTime) {
      // 创建时间
      return 0;
    } else {
      return undefined;
    }
  };

  return orderClaimDetail ? (
    <Steps
      direction={screens.md ? undefined : 'vertical'}
      labelPlacement="vertical"
      size="small"
      current={currentStep()}
    >
      <Steps.Step
        title={t('order.claimSteps.create')}
        description={orderClaimDetail.addTime}
      />
      <Steps.Step
        title={t('order.claimSteps.review')}
        description={orderClaimDetail.reviewTime}
      />
      <Steps.Step
        title={t('order.claimSteps.read')}
        description={orderClaimDetail.isRead ? orderClaimDetail.readTime : ''}
      />
      <Steps.Step
        title={t('order.claimSteps.used')}
        description={orderClaimDetail.isUsed ? orderClaimDetail.usedTime : ''}
      />
    </Steps>
  ) : (
    <Empty />
  );
};

export default ClaimProgress;
